import * as React from 'react'
import { SmallLocationCard } from '@user/components/Location'
import { BillToLocationProps } from './typings'
import { locationListStyles } from './hooks'
import { useToggleBoolean } from '@user/utils/useToggleBoolean'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

export const BillToLocation: React.FC<BillToLocationProps> = (props) => {
  const {
    billToLocation,
    onContentSizeChange,
    variant,
    readonly,
    includeHeader,
    ...rest
  } = props

  const paddingLeft = variant === 'detail' ? 0 : 1

  const [open, toggleOpen] = useToggleBoolean()

  return (
    <Box pr={1} pl={paddingLeft}>
      {includeHeader && (
        <Box mb={1.5}>
          <Typography sx={locationListStyles.header}>Bill-to</Typography>
        </Box>
      )}
      <SmallLocationCard
        {...rest}
        open={open}
        toggleOpen={toggleOpen}
        location={billToLocation}
        onTransitionEnd={onContentSizeChange}
        isEditable={true}
      />
    </Box>
  )
}
BillToLocation.displayName = 'BillToLocation'
